<template>
  <div id="teams-btn" class="full-width">
    <button
      :disabled="disabled"
      @click.stop="showMemberModalFn"
      class="tw-text-gray-700 tw-cursor-pointer hover:tw-bg-transparent hover:tw-text-primary tw-block tw-px-4 tw-py-2 tw-text-sm tw-w-full tw-text-left"
    >
      {{ title }}
    </button>
    <Teleport to="#teleport-modal">
      <TeamMembersModal
        v-if="showMemberModal"
        @close-modal="showMemberModal = false"
        @success="toggleSuccessModal"
        :role="role"
      />
    </Teleport>
  </div>
</template>
    
<script setup>
import TeamMembersModal from "./TeamMembersModal.vue";
import { ref } from "vue";


const emit = defineEmits(["member-removed"]);

const props = defineProps({
  title: {
    type: String,
    default: () => "",
    required: true,
  },
  buttonType: {
    type: String,
    required: false,
    default: () => "",
  },
  disabled: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  role: {
    type: Object,
    default: () => {},
  },
  close: Function
});

const showMemberModal = ref(false);
const showSuccessModal = ref(false);

const toggleSuccessModal = () => {
  showSuccessModal.value = true;
  showMemberModal.value = false;

  emit("member-removed");
};

const showMemberModalFn = () => {
  showMemberModal.value = true;
  
  if (props.close) {
    props.close()
  }
};
</script>
    
  <style scoped>
.full-width {
  width: 100%;
}

.padding {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
</style>